// Utility function to completely clear all authentication data
// This can be called from browser console if needed
export const clearAllAuthData = () => {
  // Clear all possible token storage locations
  localStorage.removeItem('auth_token')
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('user')
  localStorage.removeItem('token')
  
  // Clear session storage as well
  sessionStorage.removeItem('auth_token')
  sessionStorage.removeItem('accessToken')
  sessionStorage.removeItem('refresh_token')
  sessionStorage.removeItem('refreshToken')
  sessionStorage.removeItem('user')
  sessionStorage.removeItem('token')
  
  // Clear any cookies that might exist
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/")
  })
  
  console.log('All authentication data cleared')
  
  // Reload the page to reset the application state
  window.location.href = '/login'
}

// Make it available globally for debugging
if (typeof window !== 'undefined') {
  (window as any).clearAllAuthData = clearAllAuthData
}